import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedRSConfig: {},
  repairandServiceListData:[],
  repairandServiceActivityLogData:[]
}

const jcRepairandServiceSlice = createSlice({
  name: "jobCardRepairAndService",
  initialState,
  reducers: {
    selectRSConfig: (state, { payload }) => {
      state.selectedRSConfig = payload;
    },
     setRepairandServiceListData: (state, { payload }) => {
      state.repairandServiceListData = payload;
    },
    setRepairandServiceActivityLogData: (state, { payload }) => {
      state.repairandServiceActivityLogData = payload;
    },
  }
})
const { reducer, actions } = jcRepairandServiceSlice;
export const {
  selectRSConfig,
  setRepairandServiceListData
} = actions;

export default reducer;